<template>
  <div class="containerTore" id="appTore">
    <h1>{{tore}}</h1>

  </div>
</template>
<script>

export default {
  data () {
    return {



    }
  },
  props: ['tore'],
  timers: {
  },
  methods: {

    }
  }

</script>
<style>
.containerTore{
  min-width: 33%;
  font-size: 11vw;
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>



// WEBPACK FOOTER //
// src/components/Torzaehler.vue